/**
 * Environment configuration
 *
 * Centralized access to environment variables with type safety
 */

export function getDefaultApiUrl(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/api/v1`;
  }
  return "http://localhost:3000/api/v1";
}

export const env = {
  api: {
    type: (import.meta.env.VITE_API_TYPE || "rest") as "rest" | "supabase" | "graphql",
    url: (import.meta.env.VITE_API_URL as string | undefined) || getDefaultApiUrl(),
    key: import.meta.env.VITE_API_KEY as string | undefined,
    useMockData:
      import.meta.env.VITE_USE_MOCK_DATA === "true" || import.meta.env.VITE_USE_MOCK_DATA === "1",
  },
  app: {
    name: (import.meta.env.VITE_APP_NAME as string | undefined) || "Template App",
    version: (import.meta.env.VITE_APP_VERSION as string | undefined) || "1.0.0",
  },
  sentry: {
    dsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) || "",
    // Default on when a DSN is present; set VITE_SENTRY_ENABLED=false to force-disable.
    enabled: import.meta.env.VITE_SENTRY_ENABLED !== "false",
  },
} as const;
